import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Layout from '../dashboard/layout'

function RoutesContainer() {
    return (
        <Routes>
            <Route path='/' element={<Layout />} />
            <Route path='/' element={<Layout />} />
        </Routes>
    )
}

export default RoutesContainer